import * as z from "zod";

export const runBulkSupportV2Reconcile = {
  name: "runBulkSupportV2Reconcile" as const,
  input: z.object({
    teamIds: z.array(z.string()),
    dryRun: z.boolean(),
    closeV2Only: z.boolean().optional(),
    dedupeOpen: z.boolean().optional(),
    matchVoice: z.boolean().optional(),
    batchSize: z.number().optional(),
    staggerMinutes: z.number().optional(),
  }),
  output: z.object({
    workflowId: z.string(),
    accepted: z.array(z.string()),
    rejected: z.array(z.string()),
  }),
};
